export const styles = {
	centered: {
		height: '100vh',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	fabProgress: {
		color: 'primary.main',
		zIndex: 1
	}
};
